export default __webpack_public_path__ + "components/weather-icon/static/nightlightrain-32d49b6a1d8caf3b9eee265856a090b2.png";